import { useEffect, useState } from 'react';

export const capitalizeFLetter = string => {
  return string[0].toUpperCase() + string.slice(1);
};

const degToRad = deg => (deg * Math.PI) / 180.0;
export const displacementBetweenCity = (city0, city1) => {
  if (city0?.lon !== undefined && city0?.lat !== undefined && city1?.lon !== undefined && city1?.lat !== undefined) {
    if (city0.lat === city1.lat && city0.lon === city1.lon) {
      return 0;
    } else {
      const R = 3959.0;
      const lat1 = degToRad(Number(city0.lat)),
        lon1 = degToRad(Number(city0.lon)),
        lat2 = degToRad(Number(city1.lat)),
        lon2 = degToRad(Number(city1.lon));
      const dlon = lon2 - lon1;
      const dlat = lat2 - lat1;
      const a = Math.sin(dlat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return Math.round(R * c);
    }
  }
  return 0;
};

export const isValidEmail = value => {
  return value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(value);
};

export const idGenerator = () => {
  return Math.floor(Math.random() * 100000);
};

export const linkify = inputText => {
  let replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z0-9\\-]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  return replacedText;
};

export const geValidUrl = (url, ubSecureUrl = false) => {
  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    if (ubSecureUrl) {
      return 'http://' + url;
    }
    return 'https://' + url;
  }

  return url;
};

export const useDebounce = (value, delay) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState('');

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Return a cleanup function that will be called every time ...
      // ... useEffect is re-called. useEffect will only be re-called ...
      // ... if value changes (see the inputs array below).
      // This is how we prevent debouncedValue from changing if value is ...
      // ... changed within the delay period. Timeout gets cleared and restarted.
      // To put it in context, if the user is typing within our app's ...
      // ... search box, we don't want the debouncedValue to update until ...
      // ... they've stopped typing for more than 500ms.
      return () => {
        clearTimeout(handler);
      };
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value, delay],
  );

  return debouncedValue;
};

export function getTimeDiff(timestamp) {
  let startDate = new Date(timestamp * 1000);
  let endDate = new Date();
  const diffInMs = Math.abs(endDate - startDate);
  const diff = diffInMs / (1000 * 60);
  if (diff < 60) {
    return `${Math.round(diff)}m`;
  }
  if (diff < 24 * 60) {
    return `${Math.round(diff / 60)}h`;
  } else if (diff < 24 * 60 * 30) {
    return `${Math.round(diff / (24 * 60))}d`;
  } else {
    return `${Math.round(diff / (24 * 60 * 30))}mon`;
  }
}

export function getUserPermissions() {
  const admin_session = localStorage.getItem('admin-session');
  const session = admin_session && JSON.parse(admin_session);
  const permissions = (session && session.info && session.info.admin_permissions) || {};
  return permissions;
}
